import * as React from 'react';

import { ListingSkeleton } from '../../../../common/components/OfferCardHorizontal/components/OfferCardSkeleton';

export const ListingDesktopLoading = () => {
  return <ListingSkeleton count={8} />;
};
